<template>
	<div class="feedPage" v-loading.fullscreen.lock="fullscreenLoading">
		<userHeader bag="#fff" />
		<fuHeader />
		<div class="bodyWrapper">
			<div class="gudBtns">
				<div class="gudBtnItem gudBack supHove3" @click="$router.back()">
					<img src="@/assets/img/back.svg" alt="" />
					<span>返回</span>
				</div>
			</div>
			<div class="dyingBox">
				<div class="dyingHg">
					<div class="dyingHgLef">
						<!-- :audioUrl="vFlag.audioUrl" -->
						<myVideo v-if="viFlag" :audioUrl="''" :subtitlingUrl="vFlag.subtitlingUrl" :videoUrl="vFlag.videoUrl" pyFlag="py" />
					</div>
					<div class="dyingHgRig">
						<div class="dyingHgRTit">经典原音片段赏析</div>
						<div class="dyingHgRBox" v-if="dyData.length">
							<div
								class="dyingHgRItem"
								:title="item.title"
								@click="vTabFn(item)"
								:class="vFlag.webpageResourceId == item.webpageResourceId ? 'active' : ''"
								v-for="(item, index) in dyData"
								:key="index"
							>
								<img v-if="vFlag.webpageResourceId == item.webpageResourceId" src="@/assets/img/bfang.gif" alt="" />
								{{ item.title }}
							</div>
						</div>
						<div class="dyingHgRBox" v-if="!dyData.length">
							<el-empty description="暂无片段"></el-empty>
						</div>
					</div>
				</div>
				<div class="dyingBot">
					<div class="dyingBotTit">全部电影推荐</div>
					<div class="dyingBotBox" v-if="perData.length">
						<div class="dyingBotItem supHove5" @click="btnFn(item)" v-for="(item, index) in perData" :key="index">
							<div class="dyingBotImg">
								<el-image :src="$imgUrl + item?.coverImg" lazy></el-image>
							</div>
							<h1 :title="item.title">{{ item.title }}</h1>
							<p v-html="$extractText(item.content.replace(/&nbsp;/g, ''))" :title="$extractText(item.content.replace(/&nbsp;/g, ''))"></p>
						</div>
					</div>
					<fenye v-if="perData.length" :total="total" :pSize="12" ref="fybox" @dataFn="perList" />
					<div class="dyingBotBox dyingBotBox1" v-if="!perData.length">
						<el-empty description="暂无推荐"></el-empty>
					</div>
				</div>
			</div>
		</div>
		<foot />
	</div>
</template>

<script>
import userHeader from '@/components/hearder/userHeader';
import foot from '@/components/foot/foot';
import fenye from '@/components/pubComponents/fenye';
import fuHeader from '@/components/hearder/fuHeader';
import myVideo from '@/components/pubComponents/myVideo';

export default {
	name: 'dianyingHome',
	data() {
		return {
			keywords: '',
			perData: [],
			total: 0,
			vFlag: {},
			viFlag: false,
			dyData: [],
			fullscreenLoading: false
		};
	},
	components: {
		userHeader,
		foot,
		fuHeader,
		fenye,
		myVideo
	},
	methods: {
		vTabFn(item) {
			this.vFlag = item;
			this.viFlag = false;
			this.$nextTick(() => {
				this.viFlag = true;
			});
		},
		btnFn(item) {
			this.$router.push({
				path: './scDec',
				query: {
					type: 4,
					txt: item.title,
					webpageResourceId: item.webpageResourceId,
					crumFlag: 1,
					tabFtxt: ['首页', '电影列表']
				}
			});
		},
		perList(data) {
			let pre = '';
			if (data) {
				pre = {
					pageNum: data.pageNum,
					pageSize: this.$refs['fybox']?.pageSize || 10
				};
			} else {
				pre = {
					pageNum: this.$refs['fybox']?.pageNum,
					pageSize: this.$refs['fybox']?.pageSize
				};
			}
			this.fullscreenLoading = true;
			this.$http
				.get('api/app/yydWebpageResource/list', {
					params: {
						type: 4,
						recommended: 1,
						...pre
					}
				})
				.then((res) => {
					this.fullscreenLoading = false;
					if (res.code == 200) {
						this.perData = res.rows || [];
						this.total = res.total;
					}
				});
		},
		init() {
			this.fullscreenLoading = true;
			this.$http
				.get('api/app/yydWebpageResource/list', {
					params: {
						type: 4,
						isClassic: 1
					}
				})
				.then((res) => {
					this.fullscreenLoading = false;
					if (res.code == 200) {
						this.dyData =
							res.rows.filter((item) => {
								// if(item.audioUrl){
								return item;
								// }
							}) || [];
						if (res.rows.length) {
							this.vFlag = res.rows[0];
							this.viFlag = true;
						}
					}
				});
			this.perList({
				pageNum: 1,
				pageSize: 12
			});
		}
	},
	mounted() {
		this.init();
	}
};
</script>
<style lang="scss" scoped>
.feedPage {
	background: #f5f5f5;
}
.dyingBox {
	width: 1200px;
	margin: 10px auto 0;
	.dyingBot {
		margin-top: 38px;
		.dyingBotTit {
			font-size: 22px;
			color: #000000;
			font-weight: bold;
			margin-bottom: 16px;
		}
		.dyingBotBox {
			display: flex;
			flex-wrap: wrap;
			.dyingBotItem {
				width: calc((100% - 55px) / 6);
				height: 348px;
				background: #ffffff;
				border-radius: 4px;
				padding: 15px 14px;
				margin: 0 11px 15px 0;
				box-sizing: border-box;
				cursor: pointer;
				&:nth-of-type(6n) {
					margin-right: 0;
				}
				.dyingBotImg {
					height: 249px;
					margin-bottom: 19px;
					img {
						width: 100%;
						height: 100%;
						border-radius: 4px;
					}
				}
				h1 {
					font-size: 18px;
					color: #000000;
					font-weight: bold;
					// 超出多行省略号
					overflow: hidden; /* 确保超出容器的内容被裁剪 */
					white-space: nowrap; /* 确保文本在一行内显示 */
					text-overflow: ellipsis; /* 超出部分显示省略号 */
				}
				p {
					font-size: 14px;
					color: #8f9190;
					margin-top: 11px;
					// 超出多行省略号
					overflow: hidden; /* 确保超出容器的内容被裁剪 */
					white-space: nowrap; /* 确保文本在一行内显示 */
					text-overflow: ellipsis; /* 超出部分显示省略号 */
				}
			}
		}
		.dyingBotBox1 {
			justify-content: center;
			padding-bottom: 20px;
		}
	}
	.dyingHg {
		display: flex;
		.dyingHgLef {
			flex: 1;
			height: 501px;
		}
		.dyingHgRig {
			width: 256px;
			margin-left: 10px;
			background: #ffffff;
			border-radius: 6px;
			padding: 0 15px;
			height: 501px;

			.dyingHgRTit {
				padding-left: 3px;
				height: 52px;
				display: flex;
				align-items: center;
				font-size: 18px;
				color: #000000;
				font-weight: bold;
			}
			.dyingHgRBox {
				height: 428px;
				overflow-y: auto;
				&::-webkit-scrollbar {
					width: 0;
				}
				.dyingHgRItem {
					height: 39px;
					line-height: 39px;
					padding-left: 10px;
					font-size: 16px;
					color: #000000;
					cursor: pointer;
					margin-bottom: 11px;
					overflow: hidden; /* 确保超出容器的内容被裁剪 */
					white-space: nowrap; /* 确保文本在一行内显示 */
					text-overflow: ellipsis; /* 超出部分显示省略号 */
					&:last-of-type {
						margin-bottom: 0;
					}
					img {
						width: 18px;
						height: 18px;
						margin-right: 9px;
					}
				}
				.active {
					background: rgba(29, 123, 58, 0.06);
					border-radius: 4px;
					color: #1d7b3a;
				}
			}
		}
	}
}
</style>
